import React, { useState, useEffect } from 'react';
import Form from 'olive-react-myoneui/lib/Form';
import Button from 'olive-react-myoneui/lib/Button';

import DropdownCommon from '../DropdownCommon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useDispatch, useSelector } from 'react-redux';
import { setContentFilterData, resetContentFilterData } from '../../../../reducers/contentFilterSlice';
import { getCatgories } from '../../../../api/afterLogin/categories';

const ArchiveFilterMobile = ({className}) => {
  const configData = useSelector((state) => state.config);
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const categoryData = async () => {
      const categories = await getCatgories(configData.access_token);
      setCategories(categories.data);
    };
    categoryData();
  }, []);

  const enrollmentStatusOptions = [
    { id: 1, name: 'All' },
    { id: 2, name: 'In Progress' },
    { id: 3, name: 'Not Started' },
    { id: 4, name: 'Completed' },
  ];


  const courseTypeOptions = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Online' },
    { id: 3, name: 'Offline' },
    { id: 4, name: 'Blended Learning' },
    { id: 5, name: 'Upcoming Courses' },
  ];

  const categoryOptions = [
    { id: 0, name: 'All' },
    ...(categories?.map((cat) => ({
      id: cat.id,
      name: cat.ctName,
    })) || [])
  ];

  const courseValidityOptions = [
    { id: 1, name: 'Lifetime'},
    { id: 2, name: '10 Days'},
    { id: 3, name: '30 Days'},
    { id: 4, name: '90 Days'},
    { id: 5, name: 'Validity Date'},
  ];

  const [selectedFilters, setSelectedFilters] = useState({
    enrollmentStatus: enrollmentStatusOptions[0],
    courseValidity: courseValidityOptions[0],
    courseType: courseTypeOptions[0],
    category: {id: 0, name: 'All'}
  });

  const handleDropdownChange = (filterKey, selectedItem) => {
    setSelectedFilters((prevState) => ({
      ...prevState,
      [filterKey]: selectedItem,
    }));
  };

  const handleApplyFilter = () => {
    const filteredValue = {
      selectedFilters: {
        enrollmentStatus: selectedFilters.enrollmentStatus.id !== 1 ? [selectedFilters.enrollmentStatus.value] : [],
        courseType: selectedFilters.courseType.id !== 1 ? [selectedFilters.courseType.name] : [],
        category: selectedFilters.category.id !== 0 ? [selectedFilters.category.id] : [],
      },
      categories
    };
    dispatch(setContentFilterData(filteredValue));
  };

  const isApplyButtonEnabled =
    selectedFilters.enrollmentStatus.id !== 1 ||
    selectedFilters.courseValidity.id !== 1 ||
    selectedFilters.courseType.id !== 1 ||
    selectedFilters.category.id !== 0 ||
    (selectedFilters.courseValidity.id === 6 && selectedDate);

  const resetFilters = () => {
    setSelectedFilters({
      enrollmentStatus: enrollmentStatusOptions[0],
      courseValidity: courseValidityOptions[0],
      courseType: courseTypeOptions[0],
      category: {id: 0, name: 'All'}
    });
    setSelectedDate(null);
    dispatch(resetContentFilterData());
  };

  return (
    <div className={`myk__stu-courses-filter-wrapper ${className || ''}`}>
      <div className="myk__stu-filter-header d-flex align-items-center justify-content-between gap-2">
        <h3>Filter</h3>
      </div>
      {/* Enrollment Status Filter */}
      <div className="myk__stu-filter-inner-wrapper">
        <div className="myk__stu-filter-group">
          <h4>Enrollment Status</h4>
            <DropdownCommon
              label="Enrollment Status"
              items={enrollmentStatusOptions}
              value={selectedFilters.enrollmentStatus}
              onChange={(item) => handleDropdownChange('enrollmentStatus', item)}
            />
        </div>

        {/* Category Filter */}
        <div className="myk__stu-filter-group myk__stu-filterbycat">
          <h4>Category</h4>
          <DropdownCommon
            label="Category"
            items={categoryOptions}
            value={selectedFilters.category}
            onChange={(item) => handleDropdownChange('category', item)}
          />
        </div>

        {/* Filter Actions */}
        <div className="myk__stu-filter-actions d-flex align-items-center justify-content-end">
          <Button variant="default" onClick={resetFilters}>Reset</Button>
          <Button variant="primary" onClick={handleApplyFilter} disabled={!isApplyButtonEnabled}>
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ArchiveFilterMobile;
